<template>
    <button :class="colour" class="swm-button" @click="$emit('click')"><slot>Button</slot></button>
</template>

<style>
  button.swm-button {
    cursor: pointer;
    border-radius: 3px;
    background-color: transparent;
    border: 1px solid #4274cb;
    display: inline-block;
    padding: 4px 8px;
    text-align: center;
    vertical-align: middle;
    font-size: 1.5rem;
    line-height: 1.5;
    white-space: nowrap;
  }
  button.swm-button.success {
    border-color: #3c763d; /* #2bbf69;   */
    background-color: #dff0d8; /** #aedcc1; **/
    color: #3c763d;
  }
  button.swm-button.outline-success {
      border-color: #3c763d; /* #2bbf69;   */
      background-color: white; /** #aedcc1; **/
      color: #3c763d;
  }
</style>

<script>
export default {
  props: {
      icon: {
          type: String
      },
      colour: {
          type: String
      }
  },
  data: function () {
    return {
    }
  },
  computed: {
    btnClass() {
        let theClass = this.colour.length > 0 ? this.colour : 'default';
      return 'swm-button ' + theClass;
    },
  },
  mounted: function () {
  },
  destroyed: function () {
  },
  methods: {

  }
}
</script>
